import { render } from "./BranchSelect.vue?vue&type=template&id=3fd45391&scoped=true"
import script from "./BranchSelect.vue?vue&type=script&lang=js"
export * from "./BranchSelect.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd45391"]])

export default __exports__